"use strict";

var _jquery = _interopRequireDefault(require("../gulp/node_modules/jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

window.$ = window.jQuery = _jquery["default"];

require("../gulp/node_modules/jquery-ui-dist/jquery-ui");

require("./modules/datepicker-fr.js");

var nform = {
  ui: {
    nfSelect: false
  },
  init: function init() {
    this.bindUI();
    this.bindEvents();
    this.nformDateInit();
    this.nformVerifyConditions();
    this.nformCustomSelectInit();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  },
  bindUI: function bindUI() {
    this.ui.$form = $('.js-nform-form');
    this.ui.$upload = $('.js-nform-upload');
    this.ui.$uploadRemove = $('.js-nform-upload-delete');
    this.ui.$rating = $('.js-nform-rating-item');
    this.ui.$ratingChoice = $('.js-nform-rating-item .js-nform-choice');
    this.ui.$date = $('.js-nform-date');
    this.ui.$input = $(':input');
    this.ui.$submit = $('.js-nform-submit');
    this.ui.$choice = $('.js-nform-choice');
    this.ui.$content = $('.js-nform-content');
  },
  bindEvents: function bindEvents() {
    var _this = this;

    this.ui.$upload.on('keydown', function (e) {
      return _this.nformUploadDelPress(e);
    });
    this.ui.$upload.on('dragenter', function (e) {
      return _this.nformUploadDragover(e);
    });
    this.ui.$upload.on('dragleave', function (e) {
      return _this.nformUploadDragout(e);
    });
    this.ui.$upload.on('drop', function (e) {
      return _this.nformUploadDragout(e);
    });
    this.ui.$upload.on('change', function (e) {
      return _this.nformUpload(e);
    });
    this.ui.$uploadRemove.on('click', function (e) {
      return _this.nformUploadRemove(e);
    });
    this.ui.$rating.on('click', function (e) {
      return _this.nformRating(e);
    });
    this.ui.$ratingChoice.on('focusin', function (e) {
      return _this.nformRating(e, "IN");
    });
    this.ui.$ratingChoice.on('focusout', function (e) {
      return _this.nformRating(e, "OUT");
    });
    this.ui.$input.on('invalid', function (e) {
      return _this.nformOnInvalidInput(e);
    });
    this.ui.$input.on('input', function (e) {
      return _this.nformOnInput(e);
    });
    this.ui.$choice.on('change', function () {
      return _this.nformVerifyConditions();
    });
    this.ui.$content.on('click', 'option[data-url]', function (e) {
      if ($(e.currentTarget).data('url') !== '') {
        window.location.replace($(_this).data('url'));
      }
    });
  },
  nformUploadDragout: function nformUploadDragout(e) {
    $(e.currentTarget).removeClass('is-dragover');
  },
  nformUploadDragover: function nformUploadDragover(e) {
    $(e.currentTarget).addClass('is-dragover');
  },
  nformUpload: function nformUpload(e) {
    var $input = $(e.currentTarget);
    var $inputHolder = $input.closest('.js-nform-upload-holder');
    var fileName = e.currentTarget.files[0].name;
    var extension = fileName.substr(fileName.indexOf('.'));
    $inputHolder.addClass('has-file');
    $inputHolder.find('.js-nform-upload-name').text(fileName);
    $inputHolder.find('.js-nform-upload-extension').text(extension);
  },
  nformUploadDelPress: function nformUploadDelPress(e) {
    var key = e.key;

    if (key == "Backspace" || key == "Delete") {
      this.nformUploadRemove(e);
    }
  },
  nformUploadRemove: function nformUploadRemove(e) {
    e.preventDefault();
    var $inputHolder = $(e.currentTarget).closest('.js-nform-upload-holder');
    var $input = $inputHolder.find('.js-nform-upload');
    $inputHolder.removeClass('has-file');
    $input.val("");
  },
  nformRating: function nformRating(e, focus) {
    var $this = $(e.currentTarget);
    var $checkboxes = $this.closest('.js-nform-rating').find('.js-nform-rating-item');

    if (focus && focus == 'IN') {
      $this.closest('.js-nform-rating-item').addClass('is-focused');
    } else if (focus && focus == 'OUT') {
      $this.closest('.js-nform-rating-item').removeClass('is-focused');
    } else if ($this.find('.js-nform-choice').prop("checked")) {
      $checkboxes.removeClass('is-active');
      $this.addClass('is-active');
    }
  },
  nformDateInit: function nformDateInit() {
    this.ui.$date.each(function (i, e) {
      var before = $(e).data('before');
      var after = $(e).data('after');
      var defaultDate = $(e).data('default-date');

      if (defaultDate) {
        defaultDate = new Date(defaultDate);
      }

      $.datepicker.setDefaults($.datepicker.regional['fr']);
      $(e).datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "c-60:c+60",
        showOtherMonths: true,
        selectOtherMonths: true,
        dateFormat: 'dd/mm/yy',
        maxDate: before,
        minDate: after,
        defaultDate: defaultDate,
        prevText: "prev",
        nextText: "next"
      });
    });
  },
  nformOnInvalidInput: function nformOnInvalidInput(e) {
    var $this = $(e.currentTarget);
    $this.closest('.nform__input').addClass('is-invalid');

    if (e.currentTarget.getAttribute('data-validity-message')) {
      e.currentTarget.setCustomValidity(e.currentTarget.getAttribute('data-validity-message'));
    }
  },
  nformOnInput: function nformOnInput(e) {
    var $this = $(e.currentTarget);
    $this.closest('.nform__input').removeClass('is-invalid');
    e.currentTarget.setCustomValidity('');
  },
  nformVerifyConditions: function nformVerifyConditions() {
    var _this2 = this;

    var verifiedConditions = [];
    $('.js-nform-select').each(function (i, s) {
      var elementId = $(s).data('elementId');
      var valueId = $(s).find('option[value="' + $(s).val() + '"]').data('valueId');
      $('div[data-conditionned-by]').each(function () {
        var elementWrapper = $(this);
        $(this).data('conditionned-by').forEach(function (condition) {
          if (condition.elementId == elementId && condition.valueId == valueId && nform.nformVerifyConditionsParent(condition.elementId, verifiedConditions)) {
            verifiedConditions.push(elementWrapper);
          }
        });
      });
    });
    $('.js-nform-choice').each(function (i, c) {
      var elementId = $(c).closest('.nform__input-choices').data('elementId');
      var valueId = false;

      if ($(c).is(':checked')) {
        valueId = $(c).data('valueId');
      }

      $('div[data-conditionned-by]').each(function () {
        var elementWrapper = $(this);
        $(this).data('conditionnedBy').forEach(function (condition) {
          if (condition.elementId == elementId && condition.valueId == valueId && nform.nformVerifyConditionsParent(condition.elementId, verifiedConditions)) {
            verifiedConditions.push(elementWrapper);
          }
        });
      });
    });

    if (this.ui.nfSelect && $('div[data-conditionned-by]').find('.js-nform-select').nfSelect("instance")) {
      $('div[data-conditionned-by]').find('.js-nform-select').nfSelect("disable");
    }

    $('div[data-conditionned-by]').find('input').prop("disabled", true);
    $('div[data-conditionned-by]').find('textarea').prop("disabled", true);
    $('div[data-conditionned-by]').addClass('hide');
    verifiedConditions.forEach(function (elementWrapper) {
      if (_this2.ui.nfSelect && elementWrapper.find('.js-nform-select').nfSelect("instance")) {
        elementWrapper.find('.js-nform-select').nfSelect("enable");
      }

      elementWrapper.find('input').prop("disabled", false);
      elementWrapper.find('textarea').prop("disabled", false);
      elementWrapper.removeClass('hide');
    });
  },
  nformVerifyConditionsParent: function nformVerifyConditionsParent(elementId, verifiedConditions) {
    var element = $('.nform__input-choices[data-element-id=' + elementId + ']');
    var parentConditionned = element.closest('div[data-conditionned-by]');

    if (parentConditionned.length) {
      return verifiedConditions.findIndex(function (el) {
        return el.get(0) == parentConditionned.get(0);
      }) > -1;
    }

    return true;
  },
  nformCustomSelectInit: function nformCustomSelectInit() {
    var _this3 = this;

    // INIT CUSTOM SELECT
    $.widget("custom.nfSelect", $.ui.selectmenu, {
      _renderItem: function _renderItem(ul, item) {
        var li = $("<li>", {
          "class": item.element.attr("class") //access the original item's class

        }),
            wrapper = $("<div>", {
          text: item.label
        });

        if (item.disabled) {
          li.addClass("ui-state-disabled");
        }

        if (item.element.attr("data-url")) {
          li.attr('data-url', item.element.attr("data-url"));
        }

        return li.append(wrapper).appendTo(ul);
      }
    });
    $('.js-nform-select').each(function (i, s) {
      var selectClass = "nform__input-select-menu";

      if ($(s).closest('.nform__input').data('double') == true) {
        selectClass += " nform__input-select-menu--double";
      }

      $(s).nfSelect({
        classes: {
          "ui-selectmenu-menu": selectClass,
          "ui-selectmenu-button": "js-nform-select-button"
        },
        create: function create() {
          _this3.ui.nfSelect = true;
        },
        change: function change(event, ui) {
          _this3.nformVerifyConditions();

          var url = $(ui.item.element).data("url");

          if (url) {
            window.location.href = url;
          }
        }
      });
    });
  }
};
$(function () {
  var METHOD_GET = 'GET';
  var METHOD_POST = 'POST';
  var METHOD_PUT = 'PUT';
  var METHOD_DELETE = 'DELETE';
  var firstFocus = null;
  nform.init(); // Handle first focus

  $(':input').on("focus", function () {
    return onFirstFocus();
  });
  $('.js-nform-form').on("click", ".js-nform-select-button", function () {
    return onFirstFocus();
  });

  function onFirstFocus() {
    if (firstFocus == null) {
      var today = dateFormatNow();
      $('#form_dateStart').val(today);
      var urlSource = $('.js-nform-submit').attr('data-url');
      $.ajax({
        type: 'POST',
        url: urlSource,
        data: {
          'count': true
        },
        success: function success(data) {}
      });
      firstFocus = 1;
    }
  }

  function dateFormatNow() {
    var d = new Date();
    var date_now = new Date().toJSON().slice(0, 11);
    var time_hours = d.getHours();
    var time_min = d.getUTCMinutes();
    var time_sec = d.getUTCSeconds();
    return date_now + time_hours + ':' + time_min + ':' + time_sec;
  } // Handle submit


  $(".nform__content").on('submit', '#form_custom_element', function (e) {
    e.preventDefault();
    $('.nform__general-errors').find('div').remove();
    $('.nform__input-error').find('ul').remove();
    var $submit = $('.js-nform-submit');
    $submit.addClass('is-disabled');
    var form = document.getElementById("form_custom_element");
    var data = new FormData(form);
    var urlSource = $('.js-nform-submit').attr('data-url-submit');
    $.ajax({
      url: urlSource,
      type: METHOD_POST,
      data: data,
      processData: false,
      contentType: false,
      success: function success(data, textStatus, jqXHR) {
        // redirect if possible
        if (data.redirect) {
          window.location.href = data.redirect;
        } // show validation page


        $('form').remove();
        $('.nform__content').append(data);
        $('.js-nform-submit').removeClass('is-disabled');
        nform.init();
      },
      error: function error(data, textStatus, errorThrown) {
        $('.nform__general-errors').html(data.responseJSON);
        $submit.removeClass('is-disabled'); // scrolltop

        $('html, body').animate({
          scrollTop: $(".js-nform-content").offset().top - 40
        }, 300);
      }
    });
    e.stopImmediatePropagation();
  });
});